import EditIcon from "@/assets/icons/EditIcon";
import TitleAndDescriptionForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/TitleAndDescriptionForm";
import { Heading, Paragraph } from "@/components/ui/Typography";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react";
import { sanitizeHtml } from "@/utils/helpers/html";
const NewsFeedOverview = () => {
    const { templatePayload:data, updateTemplatePayload } = useMicroSiteContext();
  
      const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
  const [isEditing, setIsEditing] = useState(false);

      const handleSave = (formData: {title: string, description: string}) => {
        setIsEditing(false);
        const updatedPayload = {
          ...data,
          newsFeedSection: {
            ...data.newsFeedSection,
                newsFeedTitle: formData.title,
            newsFeedDescription: formData.description
        }
      };
        updateTemplatePayload(updatedPayload);
      };
    


  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full p-4 lg:p-8 gap-2  justify-center" >   
          <div className="flex items-center gap-3">
          <Heading level={3}>{data.newsFeedSection.newsFeedTitle}</Heading>
{isEdit && <EditIcon  className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
          <Paragraph className="lg:w-1/2" dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.newsFeedSection.newsFeedDescription ?? "") }} ></Paragraph>
      </div>
    )
  };

  return (
    <div>
      {isEditing ? <TitleAndDescriptionForm handleSave={handleSave} handleCancel={()=>setIsEditing(false)} data={{title: data.newsFeedSection.newsFeedTitle, description: data.newsFeedSection.newsFeedDescription}} /> : <PreviewComponent />}
    </div>
  )
}

export default NewsFeedOverview